import React from 'react';
import cls from 'classnames';
import { Avatar } from '@/components';
import { useTranslation } from 'react-i18next';
import {
  ClanJoinRequestDtoRead,
  useClanControllerApproveJoinRequestMutation,
  useClanControllerRemoveJoinRequestMutation,
} from '@/store/services/MidleNestApi.service';

interface JoinRequestItemProps extends ClanJoinRequestDtoRead {
  loading?: boolean;
}

export default function JoinRequestItem({
  loading = false,
  profile,
  message,
}: JoinRequestItemProps) {
  const { t } = useTranslation();
  const [approveJoinRequest /*, { isLoading, isSuccess }*/] =
    useClanControllerApproveJoinRequestMutation();
  const [removeJoinRequest /*, { isLoading, isSuccess }*/] =
    useClanControllerRemoveJoinRequestMutation();

  const rowCls = React.useMemo(
    () =>
      cls('w-full', {
        'not-ready': loading /*|| isLoading || isSuccess*/,
      }),
    [loading /*, isLoading*/],
  );

  const respondHandler = React.useCallback(
    async (approve: boolean) => {
      if (!profile.id) return;

      if (approve) await approveJoinRequest(profile.id).unwrap();
      else await removeJoinRequest(profile.id).unwrap();
    },
    [profile.id, approveJoinRequest, removeJoinRequest],
  );

  return (
    <>
      <tr className={rowCls}>
        <td className='flex gap-x-3 items-center py-6 text-sm leading-4 font-light'>
          {profile.user.username && (
            <Avatar
              name={profile.user.username}
              src={profile.avatar?.src}
              className='w-8 h-8 rounded-full'
            />
          )}
          {profile.user.username}
        </td>
        <td className='py-6 text-sm leading-4 font-light'>{0 /*avgXPPerDay*/}</td>
        <td className='py-6 text-sm leading-4 font-light'>{profile.currentXp}</td>
        <td className='space-x-1 py-6 text-sm leading-4 font-light text-right'>
          <button
            type='button'
            onClick={() => respondHandler(true)}
            className='w-5 h-5 rounded-sm text-xs text-white bg-green-500'
          >
            <i className='icon-check' />
          </button>
          <button
            type='button'
            onClick={() => respondHandler(false)}
            className='w-5 h-5 rounded-sm text-xs text-white bg-red-500'
          >
            <i className='icon-close' />
          </button>
        </td>
      </tr>
      <tr className={rowCls}>
        <td colSpan={4} className='p-4 bg-blue-50 rounded-md'>
          <h5 className='text-sm leading-5 font-medium'>{t('Request Message:')}</h5>
          <p className='text-sm leading-5 font-light'>{message}</p>
        </td>
      </tr>
    </>
  );
}
